module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapnum"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page8"
    }
  }), _c('a', {
    attrs: {
      "id": "page9"
    }
  }), _c('a', {
    attrs: {
      "href": "#/contents#ch1",
      "id": "rch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#939598"
    }
  }, [_vm._v("1")])])])]), _vm._v(" "), _c('div', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/contents#ch1"
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("FROM EXCEPTIONALISM TO INTERNATIONALISM")])])])]), _vm._v(" "), _c('div', {
    staticClass: "noindent",
    staticStyle: {
      "margin-top": "0em"
    }
  }, [_c('span', [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("A")]), _vm._v("merican foreign policy today is uncertain and heatedly contested. The challenges of U.S. foreign policy are of fundamental significance for U.S. national security and well-being, and for global peace and prosperity. Americans must understand how the world has changed, and how we must change our attitudes and approaches along with it.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The new National Defense Strategy of the United States (which I’ll consider in detail in "), _c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 9")]), _vm._v(") takes a dark view of the world scene today: “We are facing increased global disorder, characterized by decline in the long-standing rules-based international order—creating a security environment more complex and volatile than any we have experienced in recent memory.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fn1",
      "id": "rch1-fn1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" The world indeed seems to be a sea of problems: the ongoing Syrian war, the related European refugee crisis, ISIS and terrorist attacks across the globe, Russia’s brazen hacking of the U.S. election, China’s rising territorial claims in the South China Sea, North Korea’s growing nuclear threat, and more.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page10"
    }
  }), _vm._v("Yet I will argue that this dark view is far too deterministic and pessimistic. The world also offers a host of new positive opportunities, if we understand them and build on them. China, India, and the African Union are each home to more than a billion people with rapid economic growth and a rising middle class. The information revolution continues to advance at a dazzling rate. Robotics, artificial intelligence, and ubiquitous broadband offer the chances for dramatic breakthroughs in health care, education, and renewable energy, at home and globally.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("If U.S. foreign policy is only about the threats and not the opportunities, the United States will miss out on the rapid advances in well-being that the new technological revolution can deliver, and that would help to stabilize today’s conflict zones. The fundamental challenge facing U.S. foreign policy is to keep America safe without stumbling into needless wars, busting the military budget, breaking the world trade system, or diverting our attention and resources from the vital challenges of sustainable development.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The fiery debates around foreign policy, both today and throughout American history, are stoked by three competing visions of America’s place in the world. These camps have fundamentally different views of what is possible and desirable in our interactions with other nations.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page11"
    }
  }), _vm._v("The first group, whom I call the “exceptionalists,” argues that the United States should continue to aim for global dominance, maintained by unrivaled U.S. military superiority. This group sees U.S. military dominance as both feasible and necessary for global stability. One leading American exceptionalist, Ambassador Robert Blackwill, puts America’s strategy this way: “Since its founding, the United States has consistently pursued a grand strategy focused on acquiring and maintaining preeminent power over various rivals, first on the North American continent, then in the Western hemisphere, and finally globally.”"), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fn2",
      "id": "rch1-fn2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" Blackwill and other exceptionalists argue that America’s foreign policy, indeed its grand strategy, should be to preserve America’s dominant power in the world. Trump’s America First ideology is a variant of exceptionalism, adding xenophobia, racism, and protectionism to more traditional exceptionalist approaches.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The second group, whom I call the “realists,” argues that the United States must accept a realistic balance of power rather than U.S. dominance. So far so good, in my view. Yet like the exceptionalists, the realists argue essentially for “peace through strength.” They believe a new arms race is the necessary and inevitable price to pay to keep the balance of power and preserve U.S. security. I am adopting the term “realist” from its usage in political science. I don’t mean that “realists” are necessarily more realistic, only that they adhere to the “Realist School” of international relations. As I will explain, I find realists to be unrealistic in crucial ways.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("I am part of the third group, whom I call the “internationalists.” Internationalists argue that global cooperation between nations is not only feasible but also essential to avoid war and to sustain American and global prosperity. In their view, global cooperation would spare the world a costly and dangerous new arms race between the United States and the emerging powers, one that could easily spill over into open conflict. Moreover, global cooperation would enable the United States and the world to seize the opportunities opened by today’s technological revolution to boost economic growth while overcoming ills that include global warming, emerging diseases, and mass migration.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page12"
    }
  }), _vm._v("The term “internationalist” is sometimes used disparagingly. One might hear the gibe, “You’re no patriot, you’re an internationalist” as a typical gibe. The idea is that those who believe in global solutions are not really siding with the United States. By embracing the term “internationalist,” I want to underscore the basic idea that global cooperation boosts America’s best interests along with those of the rest of the world. Internationalists believe strongly in win-win cooperation rather than in the win-lose competition emphasized by the exceptionalists and the realists.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The coming foreign policy battles will pit these three visions against each other, most likely in a fierce pitched battle for the hearts and minds of the American people. I am firmly in the internationalist camp. I believe that American exceptionalism is a dangerous illusion for America in the twenty-first century and that balance-of-power realism is excessively pessimistic about the potential for cooperative diplomacy.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Consider the current U.S. policy debate regarding China.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("American exceptionalists see China’s rise as an unacceptable threat to U.S. dominance. They argue that the United States should invest trillions of dollars in a new arms buildup in Asia, including ballistic missile defense for American allies. They argue that the benefits to the United States of a unilateral U.S. arms buildup would far exceed the costs, with benefits in the form of enhanced U.S. prestige, global leadership, national security, and the safety of overseas investments. They call for trade and technology measures to limit China’s future economic growth. They call for a strengthened network of alliances.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Blackwill and Tellis put it this way:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('div', {
    staticClass: "noindent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page13"
    }
  }), _vm._v("Because the American effort to ‘integrate’ China into the liberal international order has now generated new threats to U.S. primacy in Asia—and could eventually result in a consequential challenge to American power globally—Washington needs a new grand strategy toward China that centers on balancing the rise of Chinese power rather than continuing to assist its ascendancy."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fn3",
      "id": "rch1-fn3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("To offer a simple numerical illustration: exceptionalists, I will suppose, call for a $5 trillion investment in new armaments, believing that this will enable the United States to extract $10 trillion in geopolitical advantages from China, for a net U.S. benefit of $5 trillion and loss to China of $10 trillion. For an American exceptionalist, the advantages of an arms buildup seem obvious, a no-brainer.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The realists agree with the exceptionalists that a unilateral U.S. military buildup will give the United States a net gain, but they believe that China will match the U.S. arms buildup. Even so, the realists argue that the United States should make the investment. Here is their reasoning.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("If China invests $5 trillion in arms while the United States does not, then China will gain $10 trillion in geopolitical advantage. If both sides arm, each spending $5 trillion, neither side gains a geopolitical advantage or suffers a geopolitical loss. They arrive at a standoff, a balance of power. If the United States arms while China does not, the United States garners a net gain of $5 trillion, equal to $10 trillion in geopolitical benefits minus the $5 trillion cost of arms.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page14"
    }
  }), _vm._v("Using the jargon of game theory, the realists argue that an arms buildup is America’s (and China’s) “dominant” strategy. If China arms, then the United States should do so as well. If China does not arm, then the United States can secure a geopolitical advantage through its own military buildup. No matter what China does, therefore, the United States should arm. Since China reasons symmetrically, both countries end up arming, and each incurs a $5 trillion cost but ends up at a geopolitical standstill. According to the realists, the $5 trillion is the unavoidable cost to pay to ensure America’s geopolitical parity with China.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Hold on, say the internationalists. Surely our two countries can come to their senses. The $5 trillion to be used for an arms race could be put toward more urgent needs, like education, health care, renewable energy, and infrastructure. Rather than an arms race, let’s agree with China that neither side will arm. Better still, let’s agree to pool some resources into new high-tech ventures to advance cutting-edge global solutions for low-carbon energy, quality education, health care for all, and other mutual goals, to achieve the kind of “smart, fair, and sustainable societies” that I wrote about in "), _c('i', [_vm._v("Building the New American Economy")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("It is this kind of cooperation that the exceptionalists scoff at and that the realists believe to be unrealistic. Again, consider the words of Blackwill and Tellis:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('div', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("There is no real prospect of building fundamental trust, “peaceful coexistence,” “mutual understanding,” a strategic partnership, or a “new type of major country relations” between the United States and China. Rather, the most that can be hoped for is caution and restrained predictability by the two sides as intense U.S.-China strategic competition becomes the new normal, and even that will be no easy task to achieve in the period ahead."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fn4",
      "id": "rch1-fn4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("The essence of careful foreign policy analysis is to size up the contrasting positions.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page15"
    }
  }), _vm._v("The exceptionalists believe that, with enough investments, the United States can maintain its military dominance in Asia. The realists, for their part, feel that an arms race with China and with Russia is inevitable, no matter what the eventual outcome. They point to the bad behavior of China and Russia as evidence that diplomacy is very unlikely to succeed. China is busy expanding its military presence in the South China Sea. Russia is hacking U.S. politics, bombing Aleppo, and destabilizing Ukraine. How could the United States possibly trust those countries?")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("As an internationalist, I say, “Not so fast.” China’s and Russia’s actions look aggressive from our point of view, but from the vantage points of China and Russia they are viewed as responses to U.S. actions. Recall the security dilemma—what looks like an offensive action to us may be a state’s attempt to defend itself. Many Chinese strategists plausibly believe that the United States will try to stifle China’s future economic growth and note that the United States outspends China on the military by more than two to one ($596 billion to $215 billion, in 2015), while deploying military bases in more than seventy countries, compared with China’s sole foreign base in Djibouti. Considered through this lens, China hardly seems like the aggressor.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Russian strategists similarly argue that the United States, not Russia, provoked the deterioration of relations in recent years. They point to U.S. meddling in Russia’s internal politics going back many years and, perhaps even more provocatively, to U.S. meddling in Ukraine as well. Russian strategists also strongly object to the U.S. attempts to make Ukraine a member of NATO—which would bring the U.S.-led military alliance right up to Russia’s border—and to NATO’s deployment of missile defense systems in Eastern Europe. Russia asserts that such missile defenses are designed to weaken Russian retaliation against U.S. aggression. (The new missile deployments follow America’s unilateral withdrawal in 2002 from the U.S.-Soviet Anti-Ballistic Missile Treaty.)")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page16"
    }
  }), _vm._v("President John F. Kennedy eloquently framed the debate between the realists and the internationalists (of which he was one) in a commencement speech at American University in 1963:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('div', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("Today the expenditure of billions of dollars every year on weapons acquired for the purpose of making sure we never need them is essential to the keeping of peace. But surely the acquisition of such idle stockpiles—which can only destroy and never create—is not the only, much less the most efficient, means of assuring peace. I speak of peace, therefore, as the necessary, rational end of rational men. I realize the pursuit of peace is not as dramatic as the pursuit of war, and frequently the words of the pursuers fall on deaf ears. But we have no more urgent task."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fn5",
      "id": "rch1-fn5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Kennedy believed that the Cold War could be overcome, and the arms race halted and eventually reversed, through rational, mutually beneficial agreements."), _c('span', {
    staticClass: "small"
  }, [_c('sup', [_c('span', {
    attrs: {
      "href": "#/notes#ch1-fn6",
      "id": "rch1-fn6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" In the same address, he offered this internationalist vision:")])]), _vm._v(" "), _c('div', {
    staticClass: "blockquote"
  }, [_c('div', {
    staticClass: "noindent"
  }, [_c('span', [_vm._v("So let us not be blind to our differences, but let us also direct attention to our common interests and the means by which those differences can be resolved. And if we cannot end now our differences, at least we can help make the world safe for diversity. For in the final analysis, our most basic common link is that we all inhabit this small planet. We all breathe the same air. We all cherish our children’s futures. And we are all mortal.")])])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page17"
    }
  }), _vm._v("This vision underpinned Kennedy’s successful drive to negotiate the Partial Nuclear Test Ban Treaty in 1963, which in turn led to the Nuclear Non-Proliferation Treaty of 1968. Both treaties are an expression of the hopes and aspirations of internationalism: that a dangerous arms race can be slowed, and eventually reversed, through diplomacy and cooperation.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("There is one more fundamental point to make about cooperation, demonstrated by game theory, tested in practice, and crucial for successful diplomacy. Cooperation is not blind trust, and it should not be naïve or unconditional. Internationalists like myself have no doubt that evil exists, and that Hitler bullied and duped the West with no intention other than war and conquest. When I speak about the gains from cooperation, it is on the basis of two beliefs: that the gains are large and mutual; and that if cooperation in fact breaks down, a country can still revert to the “realist” position.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("In game theory, one such strategy of conditional cooperation is called Tit-for-Tat (TFT). The TFT strategy is to be cooperative at the start, but if the other side reneges, to revert to a tougher position and an arms race if necessary. Yet to sustain cooperation it’s also very important not to be doctrinaire or to prejudge one’s counterparts. Most importantly, it’s vital not to mistake the defensive actions of those counterparts as aggression, or to assume that counterparts are incapable of cooperation. Both assumptions are likely to be dangerous and wrong, leading to a self-fulfilling arms race or worse.")])]), _vm._v(" "), _c('div', {
    staticClass: "tabcaption",
    attrs: {
      "id": "tab1-1"
    }
  }, [_c('span', [_c('span', {
    staticClass: "font"
  }, [_vm._v("TABLE 1.1")]), _vm._v("  Foreign Policy Positions")])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "table-head",
    staticStyle: {
      "vertical-align": "top"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "table-head",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Military power")]), _vm._v(" "), _c('td', {
    staticClass: "table-head",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Potential gains from cooperation")]), _vm._v(" "), _c('td', {
    staticClass: "table-head",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Likelihood of cooperation")]), _vm._v(" "), _c('td', {
    staticClass: "table-head",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Competition of values")]), _vm._v(" "), _c('td', {
    staticClass: "table-head",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Foreign policy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Exceptionalism")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("American dominance")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Low")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Low")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("American virtue in a world of evil")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Military dominance, low priority on diplomacy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Realism")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("American advantage with strong adversaries")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Moderate")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Occasional")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("American values in a world of diverse values")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Military buildup, cautious diplomacy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Internationalism")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Rough parity of military power")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("High")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("High")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Shared global values")]), _vm._v(" "), _c('td', {
    staticClass: "table-left-b",
    staticStyle: {
      "vertical-align": "top"
    }
  }, [_vm._v("Arms control, active diplomacy, shared global goals")])])])]), _vm._v(" "), _c('div', {
    staticClass: "indent3"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page18"
    }
  }), _c('a', {
    attrs: {
      "href": "#/#tab1-1"
    }
  }, [_vm._v("Table 1.1")]), _vm._v(" offers a schematic account of the three main foreign policy positions. As I summarize in the table, American exceptionalists believe in the dominance of American military power, the limits of cooperation, and the evil intentions of America’s adversaries. Realists believe that U.S. military strength is needed because America’s competitors will almost inevitably challenge American interests. Internationalists believe that humanity faces shared urgent challenges and vulnerabilities that make global cooperation necessary and achievable through rational diplomacy backed by threats if cooperation fails.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page19"
    }
  }), _vm._v("American exceptionalism, I will argue throughout this book, is passé, a throwback to the years after World War II when the United States dominated the world economy and was far ahead of the rest of the world in military and civilian technology. Times are very different now. The U.S. economy is actually smaller than China’s when both are measured by a common set of international prices. It is still true today that U.S. military power is vast, with an unrivaled archipelago of military bases in dozens of countries. But we have seen repeatedly that U.S. firepower cannot enforce peace on the ground, much less the political outcomes sought by the United States.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("Another fundamental change from the early postwar years is the much greater need for global cooperation regarding global warming, emerging diseases, and other environmental threats. If the United States and China come to view each other as military competitors, they are far less likely to view each other as partners in environmental sustainability. Our mind-set—conflict or cooperation—will shape not only our arms spending but also our chances to control global warming, fight newly emerging diseases, or invest together in new science and technology.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("A third fundamental change is that the world now has the established institutional machinery to sustain global cooperation, thanks to more than seventy years of the United Nations and its various component institutions. It would be especially foolhardy and indeed reckless for the United States to turn its back on these global institutions—as indeed it is already starting to do, and as we’ll consider further in "), _c('span', {
    attrs: {
      "href": "#/ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("chapter 15")]), _vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("To make the world safe in the face of global warming and ensure the best life possible not just for Americans but for all the inhabitants of this small planet, we must reconsider long-held assumptions. American exceptionalism has reached a double dead end. It’s no longer feasible, because the United States is no longer the dominant power that the exceptionalists imagine, and so it no longer works for guiding effective foreign policy—and hasn’t for a while. Yes, the United States may have “won” the Cold War (in the exceptionalist telling), but it lost the Vietnam War and made a mess of wars and CIA adventurism in Southeast Asia, Africa, the Middle East, Central America, and other places where exceptionalism crashed against on-the-ground realities.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page20"
    }
  }), _vm._v("A continuation of American exceptionalism, whether in its traditional forms or in Trump’s America First version, would spell further dangers and damage for the United States and for the world.")])]), _vm._v(" "), _c('div', {
    staticClass: "indent"
  }, [_c('span', [_vm._v("If we’re smart, we can find a safe position for the United States without the claim of global dominance. Yet to do so we must reconsider a tenet that’s been central to American identity for centuries—as we’ll see in the next chapter.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b208a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 81
// module chunks = 0